import angular from 'angular';
import { UserGroupMembershipsController } from './user-group-memberships-controller';
import userGroupMembershipsComponent from './user-group-memberships-component';

export default angular
  .module('userGroupMemberships', [])
  .controller('UserGroupMembershipsController', UserGroupMembershipsController)
  .component('userGroupMemberships', userGroupMembershipsComponent);



// WEBPACK FOOTER //
// ./src/modules/user/components/group-memberships/user-group-memberships-module.js